import { Link } from 'react-router-dom';

const stats = [
  { value: '12万+', label: '活跃同好' },
  { value: '86万+', label: '讨论帖子' },
  { value: '3200+', label: '原创安利' },
  { value: '24h', label: '全天热聊' },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[620px] md:min-h-[680px] items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20lively%20rooftop%20gathering%20at%20warm%20sunset%2C%20groups%20of%20young%20friends%20chatting%20and%20laughing%20together%20against%20a%20glowing%20city%20skyline%2C%20soft%20coral%20and%20peach%20color%20palette%2C%20warm%20golden%20hour%20glow%2C%20flat%20vector%20illustration%20art%20style%2C%20cozy%20and%20energetic%20community%20atmosphere%2C%20clean%20composition%20with%20gentle%20bokeh%20and%20floating%20paper%20lanterns&width=1600&height=900&seq=hero-main&orientation=landscape"
        alt="羞羞动漫社同好欢聚的场景插画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-24 md:py-28 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs md:text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-sparkling-2-fill text-accent-300"></i>
          动漫漫画同好的讨论交流社区
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-background-50">
          找到同好，一起
          <span className="text-accent-300">畅所欲言</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
          无论你想聊剧情走向、安利心头好，还是找同好一起追更，羞羞动漫社社区都能满足你。
          最新漫画讨论帖、热门话题、深度交流区，随时加入，畅聊不停。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/community"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-lg bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-chat-smile-3-fill"></i>
            进入讨论社区
          </Link>
          <Link
            to="/topics"
            className="inline-flex whitespace-nowrap items-center gap-2 rounded-lg bg-background-50/10 px-6 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-background-50/20 transition-colors backdrop-blur-sm"
          >
            浏览专题文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl bg-background-50/10 backdrop-blur-sm px-3 py-4 border border-background-50/15"
            >
              <p className="font-heading text-xl md:text-2xl text-accent-300">{s.value}</p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}